<section>
  <div class="footer-base-w">
    <div class="footer-base-w_text">{{ 'footer.all-rights-reserved' | translate }}</div>

    <nav class="footer-base-w_nav" aria-label="Footer Navigation">
      <ul class="footer-base-w_nav_items" role="list">
        <li *ngFor="let link of socialMediaLinks" class="footer-base-w_nav_items_item">
          <a [href]="link.url" target="_blank" rel="noopener">
            <img [src]="link.iconPath" [alt]="link.name" [title]="link.name" />
          </a>
        </li>
      </ul>
    </nav>

    <div>
      <a href="/data-protection">{{ 'footer.data-protection' | translate }}</a>
    </div>

    <div>
      <a href="/user-policy">{{ 'footer.user-policy' | translate }}</a>
    </div>

  </div>

</section>
